const vacanciesInitialState = {
  contactButtonName: '',
  headImage:         null,
  vacanciesIsLoaded: false,
  isIndexed:         false,
  items:             [],
  inCatalogLabel:    '',
  inCatalogLink:     '',
  label:             null,
  loading:           false,
  meta:              {
    title: null,
    meta:  {
      canonical:   null,
      description: null,
      keywords:    null,
    },
  },
  template:          null,
};

export default vacanciesInitialState;